export default __webpack_public_path__ + "static/media/leftBG.e5563125.png";